import type { Course } from '../../api/courses/types'

export const getNextVideoId = (course: Course, currentVideoId?: string | number): number | undefined => {
  const sections = course.sections
  if(!sections) return

  if(currentVideoId != null) {
    const orderedIds = sections.flatMap(s => s.videos ?? []).map(v => v.id)
    const idx = orderedIds.indexOf(parseInt(currentVideoId.toString(), 10))
    return idx >= 0 && idx < orderedIds.length - 1 ? orderedIds[idx + 1] : undefined
  }

  for(const section of sections) {
    if(!section.videos) continue
    for(const video of section.videos) {
      if(!video.userActivity?.watched) return video.id
    }
  }
  return
}
